import { useEffect } from "react";

const RedirectToSurbhiInfotech = () => {
    useEffect(() => {
        window.location.href = "https://www.surbhiinfotech.com/";
    })
    return (
        <div>

        </div>
    )
}

export default RedirectToSurbhiInfotech;